import { useState } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import { CampaignState, loadCampaign } from "src/utils/api/campaign";
import { AppDispatch, CoreReduxState } from "src/utils/redux/store";
import { useOnce } from "./lifecycle";

export function useAppDispatch() {
  return useDispatch<AppDispatch>();
}

// Load and return campaign
export function useCampaign() {
  const [state, load] = useState<CampaignState>({});
  useOnce(() => {
    loadCampaign().then(load);
  });
  return state;
}

export function useCoreStore() {
  return useStore<CoreReduxState>();
}

export function useCoreState() {
  return useSelector((state: CoreReduxState) => state);
}

export function useCountryCode() {
  return useSelector((state: CoreReduxState) => state.geoLocation.country_code);
}

export function useServerContext() {
  return useSelector((state: CoreReduxState) => state.serverContext);
}

export function usePlans() {
  return useSelector((state: CoreReduxState) => state.plans);
}

export function useUserData() {
  return useSelector((state: CoreReduxState) => state.userData);
}

export function useSurveyAnswers() {
  return useSelector((state: CoreReduxState) => state.surveyAnswers);
}

export function useCheckout() {
  return useSelector((state: CoreReduxState) => state.checkout);
}

export function useLanguage() {
  return useSelector((state: CoreReduxState) => state.language);
}

export function useOffers() {
  return useSelector((state: CoreReduxState) => state.offers);
}

// Use this to access upid in components. Do NOT use the query params -- that pattern is deprecated
export function useUpid() {
  return useSelector((state: CoreReduxState) => state.upid);
}

export function useGeoLocation() {
  return useSelector((state: CoreReduxState) => state.geoLocation);
}

export function usePromoCode() {
  return useSelector((state: CoreReduxState) => state.promoCode);
}
